// Module
var code = "<% if (withBorder) { %> <div class=\"shape\"> <img src=\"app/components/common/icon-maker/backgrounds/{{type}}.svg\"/> </div> <% } %> <div class=\"icon {{withBorderClass}}\" style=\"width:100%;height:100%\"> {{icon}} </div> <% if (segmentationIndicator) { %> {{segmentationIndicator}} <% } %> ";
// Exports
export default code;